import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  FirstTimeFlag,
  dropFirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { getCoverDeviation } from '../../../../selectors/deviations';
const mapStateToProps = (state: AppState) => {
  return {
    isDeviationSet: !!getCoverDeviation(state),
  };
};

const mapDispatchToProps = dispatch => ({
  hideProfileHeroAid() {
    dispatch(
      dropFirstTimeFlag({ flag: FirstTimeFlag.ProfileHeroAidNotClosed })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
